var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons-type1/envelope") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Supervisor-desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.800000, -3.000000)",
    fill: "#73818F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-type1/envelope"
  }, /*#__PURE__*/React.createElement("g", {
    id: "envelope-closed",
    transform: "translate(1.615385, 3.230769)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "17.7692308 9.80244755 17.7692308 3.12062937 12.956625 6.46153846"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0 L0,1.46853147 L8.31346154,7.23986014 C8.47052885,7.35 8.66916346,7.41608392 8.88461538,7.41608392 C9.10006731,7.41608392 9.29870192,7.35 9.45830769,7.23839161 L9.45576923,7.23986014 L17.7692308,1.46853147 L17.7692308,0 L0,0 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    points: "1.61538462 6.3513986 1.61538462 13.0332168 6.42799038 9.69230769"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9278846,11.527972 C11.5350577,11.8031748 11.0384712,11.9685315 10.5,11.9685315 C9.96152885,11.9685315 9.46494231,11.8028811 9.06608654,11.5238601 L9.07211538,11.527972 L7.61789423,10.5182098 L1.61538462,14.6853147 L1.61538462,16.1538462 L19.3846154,16.1538462 L19.3846154,14.6853147 L13.3821058,10.5182098 L11.9278846,11.527972 Z",
    id: "Shape"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2a012c7c0605ed406a3694209cc240d6.svg";
export { ForwardRef as ReactComponent };